<template>
  <div class="container">
    <div class="block1">
      <canvas id="qrcode"></canvas>
      <span class="text1">{{ $t("sharePage.text1") }}</span>
      <span class="text2">{{ $t("sharePage.text2") }}</span>
    </div>
    <div class="block2">
      <div class="block2-1">
        <input class="url-box" v-model="inviteUrl">
        <span class="copy-btn" v-clipboard:copy="inviteUrl" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ $t("sharePage.copyLink") }}</span>
      </div>
      <div class="block2-2">
        <div>
          <span class="text3">{{ $t("sharePage.text3") }}</span>
          <span class="text4">{{ $t("sharePage.text4") }}</span>
        </div>
        <div>
          <van-icon name="gift-o" size="8rem"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const QRCode = require('qrcode');
export default {
  name: 'share',
  data() {
    return {
      inviteUrl: ''
    }
  },
  mounted() {
    this.token = localStorage.getItem('token');
    this._fetch();
  },
  methods: {
      _fetch() {
          this.apiV1({
              method: 'get',
              url: '/inviteCode',
              headers: {'Authorization': this.token}
          }).then(response => {
              const { success, data } = response.data;
              if (success) {
                  this.inviteUrl = window.location.origin + '/?code=' + data;
                  const canvas = document.getElementById('qrcode')
                  QRCode.toCanvas(canvas, this.inviteUrl, function (error) {
                    if (error) console.error(error)
                  })
              }
          })
      },
      onCopy (e) {
          this.$toast.success(this.$t("common.copySucceeded"));
      },
      onError (e) {
          this.$toast.fail(this.$t("common.copyFailed"));
      }
    }
}
</script>
<style scoped lang="less">
.container {
  padding: @nav-bar-height 4rem 18rem;
  .block1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    #qrcode {
      box-sizing: border-box;
      border-radius: 4rem;
      border: 3.467rem solid #d1a587;
      width: 40rem !important;
      height: 40rem !important;
      margin-top: 16.88rem;
    }
    .text1 {
      font-size: 6.4rem;
      font-weight: bold;
      margin-top: 7.733rem;
    }
    .text2 {
      font-size: 3.2rem;
      margin-top: 3.2rem;
    }
  }
  .block2 {
    background-color: @app-theme-color4;
    border-radius: 4rem;
    border: 0.267rem solid #814000;
    padding: 4rem;
    margin-top: 10.667rem;
    .block2-1 {
      height: 8.8rem;
      font-size: 4rem;
      border-radius: 5.333rem;
      overflow: hidden;
      border: 1px solid #814000;
      display: flex;
      justify-content: center;
      align-items: center;
      .url-box {
        background-color: transparent;
        border: 0;
        margin: 0 2.4rem;
        width: 100%;
        color: @app-theme-color1;
      }
      .copy-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 37.333rem;
        height: 8.8rem;
        background-color: #814000;
        color: #fff;
        font-size: 3.733rem;
      }
    }
    .block2-2 {
      display: flex;
      align-items: center;
      margin-top: 5.333rem;
      >div:nth-child(1) {
        display: flex;
        flex-direction: column;
        .text3 {
          font-weight: bold;
        }
        .text4 {
          margin: 1.333rem;
          color: @app-theme-color3;
          font-size: 3.2rem;
        }
      }
      >div:nth-child(2) {
        margin-left: 4rem;
        width: 12rem;
        height: 12rem;
        border-radius: 12rem;
        border-color: transparent!important;
        background-color: #fae3e5!important;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
